"use client";
import { useEffect, useState } from "react";
import Searchbox from "../Searchbox/Searchbox";
import "./header.scss";
import SearchboxResult from "../SearchboxResult/SearchboxResult";
import {
  IHeaderResponseModel,
  ISearchDataResponse,
  ISearchResponseModel,
  TOptionalType,
} from "../../core/models";
import { getSearchResponse } from "../../core/api.service";

export interface HeaderState {
  isSearchActive: boolean;
  searchValue: string;
  response?: ISearchDataResponse;
  isLoading: boolean;
}

export interface IHeaderProps {
  props?: TOptionalType<IHeaderResponseModel>;
  pageId: TOptionalType<number>;
  showBack: boolean;
  handleBack: () => void;
}

export const Header = ({
  props,
  pageId,
  showBack,
  handleBack,
}: IHeaderProps) => {
  const [state, setState] = useState<HeaderState>({
    isSearchActive: true,
    searchValue: "",
    isLoading: true,
  });

  const handleSearchClick = (): void => {
    setState((prev) => ({
      ...prev,
      isSearchActive: true,
    }));
  };

  const handleCloseClick = (): void => {
    handleBack();
  };

  const handleClearSearchbar = (): void => {
    setState({
      isSearchActive: true,
      searchValue: "",
      isLoading: false,
    });
  };

  const handleSearchChange = (value: string): void => {
    setState((prev) => ({
      ...prev,
      searchValue: value,
    }));
  };

  const onClear = (): void => {
    setState((prev) => ({
      ...prev,
      searchValue: "",
    }));
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleKeyDown = (e: KeyboardEvent): void => {
    if (e.key === "Escape" && state.isSearchActive) {
      handleCloseClick();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown, state.isSearchActive]);

  useEffect(() => {
    if (state.searchValue.length > 2) {
      setState((state) => ({ ...state, isLoading: true }));
      getSearchResponse(state.searchValue, pageId?.toString() ?? "0")
        .then((response: ISearchResponseModel) => {
          setState((state) => ({
            ...state,
            response: response.data,
            isLoading: false,
          }));
        })
        .catch(() => {
          setState((state) => ({ ...state, isLoading: false }));
        });
    }
  }, [pageId, state.searchValue]);

  useEffect(() => {
    if (state.searchValue) {
      document.documentElement.classList.add("modal-layout");
    } else {
      document.documentElement.classList.remove("modal-layout");
    }
  }, [state.searchValue]);

  return (
    <header className="header">
      <div className={"searchbar " + (state.isSearchActive ? "active" : "")}>
        <div className="searchbar-container">
          <Searchbox
            onSearchChange={handleSearchChange}
            handleCloseClick={handleClearSearchbar}
            value={state.searchValue}
            placeholder={props?.placeholder}
          ></Searchbox>
          {state.searchValue && state.searchValue.length > 2 && (
            <SearchboxResult
              searchValue={state.searchValue}
              searchResponse={state.response}
              isLoading={state.isLoading}
              closeSearchResult={(): void => {
                state.searchValue = "";
              }}
            ></SearchboxResult>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
